import { Flex, Span } from '@fareye/ui'
import React from 'react'
import { MMStopsDetails } from './../../style/styled'
import { FieldValue } from './FieldValue'
import { displayTimeSecondFormat } from './function'
import { useTranslation } from '@fareye/common'
import { valueColor } from '@fareye/configs'
import { startCase } from '@fareye/utils'

export function OriginDetails({
  close,
  rowData,
  positionStyle,
  transportMode
}: any) {
  const { stops, nodes } = rowData || {}
  const { locationName: name, city } = rowData?.startLocation || {}
  const { t } = useTranslation()
  let { status, std, atd, ata, sta, eta, statusToSource, statusAtSource } = (stops || nodes)[0] || {}
  return (
    <MMStopsDetails style={{ ...positionStyle }} className="popover">
      <Flex column>
        <Span variant="h6">{city}</Span>
        <Span variant="ellipsis secondary" style={{ marginBottom: 4 }}>
          {name}
        </Span>
      </Flex>
      <FieldValue
        style={{ marginBottom: 4 }}
        labelStyle={{ color: valueColor, fontWeight: 500 }}
        label={`${t('Arrival Status')}: `}
        value={startCase(t(statusToSource)) || '-'}
      />
      <FieldValue
        style={{ marginBottom: 4 }}
        labelStyle={{ color: valueColor, fontWeight: 500 }}
        label={`${t('Departure Status')}: `}
        value={startCase(t(statusAtSource)) || '-'}
      />
      <FieldValue
        style={{ marginBottom: 4 }}
        label={`${ata?.time ? t('ETA') : t('ATA')}: `}
        value={ata?.time ? displayTimeSecondFormat(eta) || '-' : '-'}
      />
      {transportMode === 'ocean' ? (
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label="STA"
          value={displayTimeSecondFormat(sta)}
        />
      ) : null}
      {transportMode === 'ocean' ? (
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label="ATA"
          value={displayTimeSecondFormat(ata)}
        />
      ) : null}
      <FieldValue
        style={{ marginBottom: 4 }}
        valueStyle={{ color: valueColor }}
        label="STD"
        value={displayTimeSecondFormat(std)}
      />
      <FieldValue
        style={{}}
        valueStyle={{ color: valueColor }}
        label="ATD"
        value={displayTimeSecondFormat(atd)}
      />
    </MMStopsDetails>
  )
}
